// extracted by mini-css-extract-plugin
export default {"container":"WhatYouNeed_container__ANKsa","section":"WhatYouNeed_section__cdk69","cards":"WhatYouNeed_cards__A3zs9"};